import { Injectable } from '@angular/core';
import { Subject, Observable, EMPTY, BehaviorSubject } from 'rxjs';
import { loginInterface } from 'app/Model/login.Interface';
import { LoginService } from '../services/login.service';
import { ToastrServiceLocal } from '../services/toast/toastr.service';
import { map, tap, catchError, switchMap } from 'rxjs/operators';
import { MensajesHttpService } from 'app/utils/mensajesHttp/mensajes-http.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { StoreService } from '../store/store.service';
import { State } from '../store/reducers';
import * as menuActions from '../store/actions/Administracion/menus.actions';
import { environment } from 'environments/environment';
import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root'  
})
export class LoginFacadeService {
  validLogin = ['loginP1', 'loginC2', 'loginG3', 'loginDS', 'loginDI', 'loginDSA1'];
  private logeoEmpleado: number | null = null;
  //Selectores
  public Menus$ = this._store.state.pipe(map((state) => state.Menus?.menus));

  //Respuesta Acción
  private response$ = new Subject<loginInterface[]>();
  public responseAction$: Observable<loginInterface[]> = this.response$.asObservable();

  private loading$ = new BehaviorSubject<any>({ loading: false, recurso: 'POST', message: 'Cargando Logueo', messages: [] });
  public responseLoading$: Observable<any> = this.loading$.asObservable();

  private error$ = new BehaviorSubject<any>({ hasError: false, recurso: 'POST', messageError: '', errors: [] });
  public responseError$: Observable<any> = this.error$.asObservable();

  constructor(private _loginService: LoginService, private _toast: ToastrServiceLocal,
    private _mensajeHttp: MensajesHttpService, private _router: Router, private _store: StoreService<State>) {
    
  }
  login(params: any) {
    const parametro = this._loginService.getData('login');
    if (!this.validLogin.includes(parametro)) {
      // Si no existe la opción de login, borra y vuelve a inicio
      this._router.navigateByUrl('/inicio');
      return;
    }
  
    // ruta basada en el parámetro
    let ruta: string = '';
    if (parametro === 'loginP1') { ruta = 'login/loginDocente'; } 
    else if (parametro === "loginC2") { ruta = 'login/loginCoordinadorCarrera'; }
    else if (parametro === "loginG3") { ruta = 'login/loginCoordinadorGeneral'; }
    else if (parametro === "loginDS") { ruta = 'login/loginDSEP'; }
    else if (parametro === "loginDI") { ruta = 'login/loginDIPP'; }
    else if (parametro === "loginDSA1") { ruta = 'login/loginDireccionDSA'; }
  
    this.loading$.next({ loading: true, recurso: 'POST', message: 'Validando Usuario', messages: [] });
    this.error$.next({ hasError: false, recurso: 'POST', messageError: '', errors: [] });
  
    // Primero llama a la  API para validar si existe el usuario
    this._loginService.logueo('auth/v2/login', params).pipe(
      switchMap((validacionResult: any) => {
        const msj = validacionResult?.data?.table0?.[0]?.msj;
        if (msj === "ok") {
          // Si el usuario exist continua con el flujo de login 
          return this._loginService.logueoLc(ruta, params).pipe(
            tap((result: loginInterface | any) => {
              console.log(result);
              result?.user?.data?.Table0.forEach(item => {
                if (item.hijos) { item.hijos = JSON.parse(item.hijos); }
              });
  
              // Guardar datos en LocalStorage y SessionStorage
              localStorage.setItem("nombre", result?.user?.data?.Table1[0]?.nombre || '');
              const encryptedData = CryptoJS.AES.encrypt(
                JSON.stringify(result?.user.data.Table0), 
                result?.token
              ).toString();
              localStorage.setItem("MFX_01", encryptedData);
              localStorage.setItem(environment.tokenLocal, result?.token);
              sessionStorage.setItem(environment.tokenLocal, result?.token);
  
              this.loading$.next({ loading: false, recurso: 'POST', message: 'Respuesta cargada', messages: [] });
              this._toast.mensajeSuccess('Te damos la bienvenida al sistema de posgrado UNAH', 'Bienvenido');
                   
          if (result?.user?.data?.Table1[0]?.logueo === true){
            this._router.navigateByUrl('/CambioCredencial');
            this.logeoEmpleado = 1;
          }else {
          this._router.navigateByUrl('/dashboard');
          }
              // this._router.navigateByUrl('/dashboard');
            }),
            catchError((error: HttpErrorResponse) => {
              this._mensajeHttp.mostrarErrorHttp(error, 'Ocurrió un error al loguearse', '');
              this.loading$.next({ loading: false, recurso: 'POST', message: 'Error al loguearse', messages: [] });
              this.error$.next({
                hasError: true,
                recurso: 'POST',
                messageError: this._mensajeHttp.mostrarErrorHttpString(error, 'Ocurrió un error al loguearse'),
                errors: []
              });
              return EMPTY;
            })
          );
        } else {
          // Si el usuario no existe, mostrar mensaje de error
          this._toast.mensajeError('Credenciales incorrectas. Por favor, verifica tu información.', 'Error');
          this.loading$.next({ loading: false, recurso: 'POST', message: 'Usuario no encontrado', messages: [] });
          return EMPTY;  
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const msjE = error.error?.errors?.[0]?.codigo;
         if(msjE === 5 && parametro === 'loginP1' )
        {

          return this._loginService.logueoLc('login/logExDocentes', params).pipe(
            tap((result: loginInterface | any) => {
              console.log(result);
              result?.user?.data?.Table0.forEach(item => {
                if (item.hijos) { item.hijos = JSON.parse(item.hijos); }
              });
  
              // Guardar datos en LocalStorage y SessionStorage
              localStorage.setItem("nombre", result?.user?.data?.Table1[0]?.nombre || '');
              const encryptedData = CryptoJS.AES.encrypt(
                JSON.stringify(result?.user.data.Table0), 
                result?.token
              ).toString();
              localStorage.setItem("MFX_01", encryptedData);
              localStorage.setItem(environment.tokenLocal, result?.token);
              sessionStorage.setItem(environment.tokenLocal, result?.token);
  
              this.loading$.next({ loading: false, recurso: 'POST', message: 'Respuesta cargada', messages: [] });
              this._toast.mensajeSuccess('Te damos la bienvenida al sistema de posgrado UNAH', 'Bienvenido');
                   
          if (result?.user?.data?.Table1[0]?.logueo === true){
            this._router.navigateByUrl('/CambioCredencial');
            this.logeoEmpleado = 1;
          }else {
          this._router.navigateByUrl('/dashboard');
          }
              // this._router.navigateByUrl('/dashboard');
            }),
            catchError((error: HttpErrorResponse) => {
              this._mensajeHttp.mostrarErrorHttp(error, 'Ocurrió un error al loguearse', '');
              this.loading$.next({ loading: false, recurso: 'POST', message: 'Error al loguearse', messages: [] });
              this.error$.next({
                hasError: true,
                recurso: 'POST',
                messageError: this._mensajeHttp.mostrarErrorHttpString(error, 'Ocurrió un error al loguearse'),
                errors: []
              });
              return EMPTY;
            })
          );


        }
        else
        {

        // Error al validar el usuario en la nueva API
        this._mensajeHttp.mostrarErrorHttp(error, 'Error al validar el usuario', '');
        this.loading$.next({ loading: false, recurso: 'POST', message: 'Error en validación', messages: [] });
        return EMPTY;
        }
      })
    ).subscribe();
  }
 

 

  getIdProgramacion(): number | null  {
    return this.logeoEmpleado

  }

  // login(params: any) {
  //   const parametro = this._loginService.getData('login');
  //   if (!this.validLogin.includes(parametro)) { // si no existe la opcion de login, borra y vuelve a inicio
  //     this._router.navigateByUrl('/inicio');
  //     return   }
  //   let ruta: string = '';
  //   if (parametro === 'loginP1') { ruta = 'login/loginDocente' } 
  //     else if (parametro === "loginC2") { ruta = 'login/loginCoordinadorCarrera'}
  //     else if (parametro === "loginG3") { ruta = 'login/loginCoordinadorGeneral'}
  //     else if (parametro === "loginDS") { ruta = 'login/loginDSEP' }
  //     else if (parametro === "loginDI") { ruta = 'login/loginDIPP' }

  //   this.loading$.next({ loading: true, recurso: 'POST', message: 'Cargando Logueo', messages: [] });
  //   this.error$.next({ hasError: false, recurso: 'POST', messageError: '', errors: [] });

  //   const request$ = this._loginService.logueoLc(ruta, params).pipe(
  //     tap((result: loginInterface | any) => {
  //       console.log(result);
  //       result?.user?.data?.Table0.forEach(item => {
  //         if (item.hijos) {item.hijos = JSON.parse(item.hijos) }});
  //       localStorage.setItem("nombre", result?.user?.data?.Table1[0]?.nombre || '');
  //       const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(result?.user.data.Table0), result?.token).toString();  // cifrado  usando el token 
  //       localStorage.setItem("MFX_01", encryptedData);
  //       localStorage.setItem(environment.tokenLocal, result?.token);
  //       sessionStorage.setItem(environment.tokenLocal, result?.token);
        
  //       this.loading$.next({ loading: false, recurso: 'POST', message: 'Respuesta cargada', messages: [] });
  //       this._toast.mensajeSuccess('Te damos la bienvenida al sistema de posgrado UNAH', '');
  //       this._router.navigateByUrl('/dashboard');

  //     }),
  //     catchError((error: HttpErrorResponse) => {
  //       this._mensajeHttp.mostrarErrorHttp(error, 'Ocurrio un error al loguearse', '');
  //       this.loading$.next({ loading: false, recurso: 'POST', message: 'Error al loguearse', messages: [] });
  //       this.error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajeHttp.mostrarErrorHttpString(error, 'Ocurrio un error al loguearse'), errors: [] });
  //       return EMPTY;
  //     })
  //   );
  //   return request$.subscribe();
  // }

  
  

  // loginDocente(params: any) {
  //   this.loading$.next({ loading: true, recurso: 'POST', message: 'Cargando Logueo', messages: [] });
  //   this.error$.next({ hasError: false, recurso: 'POST', messageError: '', errors: [] });

  //   const request$ = this._loginService.logueo('auth/v1/login', params).pipe(
  //     tap((result: loginInterface | any) => {
  //       console.log(result);
  //       this._store.dispatch(new menuActions.GetMenus(result?.menus));
  //       localStorage.setItem("nombre", result?.nombre);
  //       // localStorage.setItem("menus", JSON.stringify(result?.menus));
  //       const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(result?.menus), result?.token).toString(); 
  //       localStorage.setItem("MFX_01", encryptedData);
  //       localStorage.setItem(environment.tokenLocal, result?.token);
  //       sessionStorage.setItem(environment.tokenLocal, result?.token);

  //       this.loading$.next({ loading: false, recurso: 'POST', message: 'Respuesta cargada', messages: [] });
  //       this._toast.mensajeSuccess('Te damos la bienvenida al sistema de agenda UNAH', '');
  //       this._router.navigateByUrl('/dashboard');

  //     }),
  //     catchError((error: HttpErrorResponse) => {
  //       this._mensajeHttp.mostrarErrorHttp(error, 'Ocurrio un error al loguearse', '');
  //       this.loading$.next({ loading: false, recurso: 'POST', message: 'Error al loguearse', messages: [] });
  //       this.error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajeHttp.mostrarErrorHttpString(error, 'Ocurrio un error al loguearse'), errors: [] });
  //       // this._router.navigateByUrl('/login');
  //       return EMPTY;
  //     })
  //   );
  //   return request$.subscribe();
  // }


}
